import React from 'react'
import { Link } from 'react-router-dom'

export default function ConfigPage() {
  // Déterminer l'URL de la documentation en fonction de l'environnement
  const getDocsUrl = () => {
    const hostname = window.location.hostname
    if (hostname.includes('dev.totemium.com')) {
      return 'https://docs-dev.totemium.com'
    }
    return 'https://docs.totemium.com'
  }

  return (
    <div className="relative overflow-hidden">
      <div aria-hidden className="absolute inset-0 -z-30 bg-gradient-to-b from-emerald-50 via-white to-white dark:from-zinc-950 dark:via-zinc-900 dark:to-zinc-900" />
      <div aria-hidden className="absolute inset-x-0 top-0 -z-40 h-[320px] bg-[radial-gradient(circle_at_top,_rgba(16,185,129,0.25),_transparent_68%)]" />

      <div className="relative mx-auto flex max-w-[1400px] flex-col gap-6 px-6 py-6">
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-zinc-900 dark:text-white">Configuration</h1>
          <p className="text-sm text-zinc-500 dark:text-zinc-400">
            Gérez vos paramètres de connexion et intégrations externes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <Link
            to="/config/wordpress"
            className="group relative overflow-hidden rounded-3xl border border-blue-200/70 bg-gradient-to-br from-blue-50/80 to-white/80 p-8 shadow-lg transition-all hover:shadow-xl hover:-translate-y-1 dark:border-blue-900/50 dark:from-blue-950/40 dark:to-zinc-950/80"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-100 dark:bg-blue-900/40">
                <svg className="h-8 w-8 text-blue-600 dark:text-blue-400" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.158 12.786l-2.698 7.84c.806.236 1.657.365 2.54.365 1.047 0 2.051-.18 2.986-.51-.024-.037-.046-.078-.065-.123l-2.763-7.572zm-5.316 3.713l-3.106-8.98c-.538 1.003-.838 2.15-.838 3.365 0 2.469 1.266 4.643 3.18 5.918-.02-.103-.038-.206-.054-.31l-.182-.993zm9.928-8.986c.54-.028.998-.085.998-.085.47-.056.415-.75-.056-.724 0 0-1.414.112-2.327.112-.858 0-2.3-.112-2.3-.112-.47-.026-.526.697-.055.724 0 0 .43.057.884.085l1.313 3.598-1.845 5.536-3.073-9.134c.54-.028.998-.085.998-.085.47-.056.415-.75-.056-.724 0 0-1.414.112-2.327.112-.164 0-.358-.004-.564-.01C6.78 3.924 9.24 2.571 12 2.571c2.072 0 3.958.79 5.375 2.086-.034-.002-.068-.007-.103-.007-.858 0-1.467.75-1.467 1.556 0 .723.415 1.333.858 2.056.332.585.72 1.333.72 2.417 0 .75-.288 1.62-.666 2.83l-.872 2.913-3.16-9.395zM12 22c-5.523 0-10-4.477-10-10S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-blue-900 dark:text-blue-100 mb-2">WordPress</h3>
                <p className="text-sm text-blue-700/80 dark:text-blue-300/80">
                  Configuration de la connexion LearnDash et synchronisation des formations
                </p>
              </div>
              <svg className="h-6 w-6 text-blue-400 dark:text-blue-600 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </Link>

          <Link
            to="/config/openai"
            className="group relative overflow-hidden rounded-3xl border border-purple-200/70 bg-gradient-to-br from-purple-50/80 to-white/80 p-8 shadow-lg transition-all hover:shadow-xl hover:-translate-y-1 dark:border-purple-900/50 dark:from-purple-950/40 dark:to-zinc-950/80"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-purple-100 dark:bg-purple-900/40">
                <svg className="h-8 w-8 text-purple-600 dark:text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-purple-900 dark:text-purple-100 mb-2">OpenAI</h3>
                <p className="text-sm text-purple-700/80 dark:text-purple-300/80">
                  Configuration de votre clé API OpenAI pour utiliser les modèles GPT
                </p>
              </div>
              <svg className="h-6 w-6 text-purple-400 dark:text-purple-600 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </Link>

          <Link
            to="/config/anthropic"
            className="group relative overflow-hidden rounded-3xl border border-orange-200/70 bg-gradient-to-br from-orange-50/80 to-white/80 p-8 shadow-lg transition-all hover:shadow-xl hover:-translate-y-1 dark:border-orange-900/50 dark:from-orange-950/40 dark:to-zinc-950/80"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-orange-100 dark:bg-orange-900/40">
                <svg className="h-8 w-8 text-orange-600 dark:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-orange-900 dark:text-orange-100 mb-2">Anthropic</h3>
                <p className="text-sm text-orange-700/80 dark:text-orange-300/80">
                  Configuration de votre clé API Anthropic pour utiliser les modèles Claude
                </p>
              </div>
              <svg className="h-6 w-6 text-orange-400 dark:text-orange-600 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </Link>

          <Link
            to="/config/sendgrid"
            className="group relative overflow-hidden rounded-3xl border border-slate-200/70 bg-gradient-to-br from-slate-50/80 to-white/80 p-8 shadow-lg transition-all hover:shadow-xl hover:-translate-y-1 dark:border-slate-700/50 dark:from-slate-950/40 dark:to-zinc-950/80"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 dark:bg-slate-800/60">
                <svg className="h-8 w-8 text-slate-700 dark:text-slate-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-2">SendGrid</h3>
                <p className="text-sm text-slate-700/80 dark:text-slate-300/80">
                  Clé API pour l’envoi des réponses email de vos agents (domaine d’envoi)
                </p>
              </div>
              <svg className="h-6 w-6 text-slate-500 transition-transform group-hover:translate-x-1 dark:text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </Link>

          <Link
            to="/integrations"
            className="group relative overflow-hidden rounded-3xl border border-emerald-200/70 bg-gradient-to-br from-emerald-50/80 to-white/80 p-8 shadow-lg transition-all hover:shadow-xl hover:-translate-y-1 dark:border-emerald-900/50 dark:from-emerald-950/40 dark:to-zinc-950/80"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-100 dark:bg-emerald-900/40">
                <svg className="h-8 w-8 text-emerald-600 dark:text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-emerald-900 dark:text-emerald-100 mb-2">Intégrations</h3>
                <p className="text-sm text-emerald-700/80 dark:text-emerald-300/80">
                  Connectez vos outils et services externes (API, WordPress, iFrame)
                </p>
              </div>
              <svg className="h-6 w-6 text-emerald-400 dark:text-emerald-600 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </Link>

          <a
            href={getDocsUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="group relative overflow-hidden rounded-3xl border border-cyan-200/70 bg-gradient-to-br from-cyan-50/80 to-white/80 p-8 shadow-lg transition-all hover:shadow-xl hover:-translate-y-1 dark:border-cyan-900/50 dark:from-cyan-950/40 dark:to-zinc-950/80"
          >
            <div className="flex items-start gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-cyan-100 dark:bg-cyan-900/40">
                <svg className="h-8 w-8 text-cyan-600 dark:text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-cyan-900 dark:text-cyan-100 mb-2">Documentation</h3>
                <p className="text-sm text-cyan-700/80 dark:text-cyan-300/80">
                  Consultez la documentation complète de la plateforme Totemium
                </p>
              </div>
              <svg className="h-6 w-6 text-cyan-400 dark:text-cyan-600 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}
